const ENDPOINT = 'UPDATEsonginfo';
function updateSongInfo(gateway, params = {}) {
    return gateway.get(updateSongInfo.endpoint, params);
}
updateSongInfo.endpoint = ENDPOINT;

export { updateSongInfo as default };
//# sourceMappingURL=updateSongInfo.js.map
